import React from 'react';
import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';
import SocialLinks from '../components/SocialLinks';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { motion } from 'motion/react';

const Contact = () => {
  const contactInfo = [
    { icon: Mail, title: "E-mail", detail: "michellicazelli@hotmail.com", sub: "Respostas em até 24h" },
    { icon: MapPin, title: "Endereço", detail: "Av. Jardelino José Moreira, 2069", sub: "Centro, Iguatemi - MS" },
    { icon: Clock, title: "Atendimento", detail: "07h às 11h e 13h às 17h", sub: "Segunda a Sexta." }
  ];

  return (
    <main>
      <PageHeader 
        title="Entre em Contato" 
        description="Estamos prontos para ouvir você. Seja para tirar dúvidas, propor parcerias ou conhecer mais sobre nosso trabalho."
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            {/* Info Column - Now full width or centered */}
            <div className="lg:col-span-12 space-y-12 max-w-3xl mx-auto text-center">
              <div className="space-y-6">
                <h2 className="text-3xl font-extrabold text-slate-900">Informações de Contato</h2>
                <p className="text-slate-600 text-lg leading-relaxed">
                  Escolha o canal de sua preferência. Nossa equipe está à disposição para ajudar.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {contactInfo.map((item, index) => (
                  <div key={index} className="space-y-3 flex flex-col items-center">
                    <div className="w-12 h-12 bg-blue-50 text-primary rounded-xl flex items-center justify-center">
                      <item.icon size={24} />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900">{item.title}</h4>
                      <p className="text-slate-600 text-sm">{item.detail}</p>
                      <p className="text-slate-400 text-xs mt-1">{item.sub}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="pt-8 border-t border-slate-100 space-y-6 flex flex-col items-center">
                <h4 className="font-bold text-slate-900">Siga-nos nas Redes Sociais</h4>
                <SocialLinks />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full h-[400px] bg-slate-100 rounded-[3rem] overflow-hidden relative border border-slate-200">
            <div className="absolute inset-0 flex items-center justify-center flex-col space-y-4 text-slate-400">
              <MapPin size={48} />
              <p className="font-medium">Mapa Interativo será carregado aqui</p>
            </div>
            {/* In a real app, you would embed a Google Map or Leaflet here */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18535.648174!2d-54.5657963!3d-23.4405567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDI2JzI0LjIiUyA1NMKwMzMnNTcuNyJX!5e0!3m2!1spt-BR!2sbr!4v1733968216145!5m2!1spt-BR!2sbr"
              style={{border:0}}
              allowFullScreen={false}
              loading="lazy"
              className="w-full h-full"
              title="UNIFIG - Av. Jardelino José Moreira, 2069, Iguatemi - MS"
              referrerPolicy="no-referrer"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
